import {IRouteShapeSingleVoyage} from "@containers/singleVoyage/types/voyage";
import {IPositionSingleVoyage} from "@containers/singleVoyage/types/position";

export const routeShapeToPositionsSingleVoyage = (routeShape: IRouteShapeSingleVoyage,): IPositionSingleVoyage[] => {
    if (routeShape?.geom?.type === 'Point') {
        const [lng, lat] = routeShape?.geom?.coordinates
        return [
            {
                lng,
                lat,
            }
        ]
    }

    if (routeShape?.geom?.type === 'LineString') {
        return routeShape?.geom?.coordinates?.map(([lng, lat]) => {
            return {
                lng,
                lat,
            }
        })
    }

    return []
}